import axios from 'axios';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';

export const champsAnnouncementState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        eventsList: null,
        membersList: null,
    };
};

export const champsAnnouncementMutations = {
    [storeMutation.setLinkingObjects]: (state, data) => {
        state.eventsList = data.eventList || null;
        state.membersList = data.profileList || null;
    },
};

export const champsAnnouncementActions = {
    [storeAction.getAnnouncementInfo]: wrapAction(
        storeAction.getAnnouncementInfo,
        ({ state, commit }, announcement) => {
            let urlPath = '';
            if (announcement.announcementId) {
                urlPath = `${state.baseURL}communities/api/communities/get-announcement-info/${announcement.communityId}/${announcement.announcementId}`;
            } else {
                urlPath = `${state.baseURL}communities/api/communities/get-announcement-info/${announcement.communityId}`;
            }
            return axios({
                url: urlPath,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setLinkingObjects, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getAllAnnouncements]: wrapAction(storeAction.getAllAnnouncements, ({ state }, communityId) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/get-all-announcements/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.createAnnouncementAPI]: wrapAction(storeAction.createAnnouncementAPI, ({ state }, announcement) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/create-announcement`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: announcement,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data.message;
            });
    }),

    [storeAction.updateAnnouncement]: wrapAction(storeAction.updateAnnouncement, ({ state }, announcement) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/update-announcement`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: announcement,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data.message;
            });
    }),

    [storeAction.deleteAnnouncements]: wrapAction(storeAction.deleteAnnouncements, ({ state }, announcement) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/delete-announcement`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: announcement,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.makeOnlineAnnouncement]: wrapAction(storeAction.makeOnlineAnnouncement, ({ state }, announcement) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/make-online-announcement`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: announcement,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

export const champsAnnouncementGetters = {
    [storeGetters.eventsList]: (state) => state.eventsList,
    [storeGetters.membersList]: (state) => state.membersList,
};

export default {
    namespaced: true,
    state: {
        initialState: champsAnnouncementState(),
        ...champsAnnouncementState(),
    },
    mutations: { ...champsAnnouncementMutations },
    actions: { ...champsAnnouncementActions },
    getters: { ...champsAnnouncementGetters },
};
